import React, { useState, useEffect, useContext } from "react";
import { Form } from "react-bootstrap";
import api, { BASE_URL } from "../../Utils/api";
import Modal from "react-bootstrap/Modal";
import { GlobalContext } from "../../Utils/GlobalContext";
import { Salvar, Cancelar } from "../Generals/buttons";


/*api.interceptors.request.use((request) => {
  const fullUrl = window.location.origin + request.url;
  return request;
});*/

const IndicesCorrecaoModal = ({
  show,
  handleClose,
  indice,
  fetchIndicesCorrecao,
}) => {
  const [nome, setNome] = useState("");
  const [ativo, setAtivo] = useState("S");
  const [error, setError] = useState(null);
  const { globalData } = useContext(GlobalContext);
  const entidadeID = globalData?.entidade_id || localStorage.getItem("entidade_id");

  useEffect(() => {
    if (!show) return;
    setError(null);
    if (indice) {
      setNome(indice.nome || "");
      setAtivo(indice.ativo || "S");
    } else {
      setNome("");
      setAtivo("S");
    }
  }, [show, indice]);

  const handleSave = async () => {
    setError(null);
    const nomeTrim = (nome || "").trim();
    if (!nomeTrim) {
      setError("Nome é obrigatório.");
      return;
    }
    const indiceData = {
      nome: nomeTrim,
      ativo,
    };

    try {
      if (indice) {
        await api.put(
          `${BASE_URL}/api/indicesCorrecao/EditarIndiceCorrecao/${indice.id}`,
          indiceData
        ); // Editar
      } else {
        await api.post(
          `${BASE_URL}/api/indicesCorrecao/InserirIndiceCorrecao/${entidadeID}`,
          indiceData
        ); // Inserir
      }
      fetchIndicesCorrecao();
      handleClose();
    } catch (err) {
      console.error("Erro ao salvar índice de correção:", err);
      setError(err.response?.data?.message || "Erro ao salvar. Tente novamente.");
    }
  };

  return (
    <Modal show={show} onHide={handleClose} backdrop="static" dialogClassName="modal-dialog-top">
      <Modal.Header closeButton style={{ background: "var(--surface-sunken)", borderColor: "var(--border-default)", paddingBottom: 12 }}>
        <Modal.Title style={{ fontSize: "1rem", fontWeight: 600, color: "var(--text-body)" }}>
          {indice ? "Índice de Correção" : "Adicionar Índice de Correção"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ background: "var(--surface-card)", color: "var(--text-body)" }}>
        {error && (
          <div className="alert alert-danger" role="alert">
            {error}
          </div>
        )}
        <Form>
          <Form.Group controlId="formNome">
            <Form.Label>Nome <span className="text-danger">*</span></Form.Label>
            <Form.Control
              type="text"
              placeholder="Informe o nome"
              value={nome}
              onChange={(e) => setNome(e.target.value)}
              required
            />
          </Form.Group>
          <Form.Group controlId="formAtivo" className="mt-3">
            <Form.Label>Situação</Form.Label>
            <Form.Select
              value={ativo}
              onChange={(e) => setAtivo(e.target.value)}
            >
              <option value="S">Ativo</option>
              <option value="N">Inativo</option>
            </Form.Select>
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer className="modal-footer-padrao">
        <div className="modal-footer-acoes-esquerda" />
        <div className="modal-footer-acoes-direita">
          <Cancelar onClick={handleClose} />
          <Salvar onClick={handleSave} />
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default IndicesCorrecaoModal;
